import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Plus, Eye, Zap, CheckCircle } from 'lucide-react';
import CreateCandidateModal from '../pages/candidate/CreateCandidateModal';

const TestModalCandidat = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [candidates, setCandidates] = useState([]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <motion.div
        className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-6 mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="flex items-center space-x-3 mb-6">
          <div className="bg-blue-600 rounded-lg p-2">
            <User className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-800">
              Test Modal Candidat Optimisée
            </h1>
            <p className="text-slate-600">
              Modal redesignée avec optimisations de performance
            </p>
          </div>
        </div>

        {/* Indicateurs d'optimisation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <motion.div
            className="bg-green-50 border border-green-200 rounded-lg p-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <div className="flex items-center space-x-2 mb-2">
              <Zap className="w-5 h-5 text-green-600" />
              <h3 className="font-semibold text-green-800">Performance</h3>
            </div>
            <p className="text-green-700 text-sm">
              Limite à 50 clients max pour éviter les lags
            </p>
          </motion.div>

          <motion.div
            className="bg-blue-50 border border-blue-200 rounded-lg p-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <div className="flex items-center space-x-2 mb-2">
              <CheckCircle className="w-5 h-5 text-blue-600" />
              <h3 className="font-semibold text-blue-800">Position Corrigée</h3>
            </div>
            <p className="text-blue-700 text-sm">
              Dropdown correctement positionné avec z-index
            </p>
          </motion.div>

          <motion.div
            className="bg-purple-50 border border-purple-200 rounded-lg p-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <div className="flex items-center space-x-2 mb-2">
              <User className="w-5 h-5 text-purple-600" />
              <h3 className="font-semibold text-purple-800">UX Optimisée</h3>
            </div>
            <p className="text-purple-700 text-sm">
              Animations progressives et interactions fluides
            </p>
          </motion.div>
        </div>

        <div className="flex space-x-4">
          <motion.button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 font-medium shadow-lg"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Plus className="w-4 h-4" />
            <span>Ouvrir Modal Candidat</span>
          </motion.button>

          <motion.button
            onClick={() => console.log('Candidats actuels:', candidates)}
            className="flex items-center space-x-2 bg-gray-100 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Eye className="w-4 h-4" />
            <span>Voir Candidats ({candidates.length})</span>
          </motion.button>
        </div>

        {candidates.length > 0 && (
          <motion.div
            className="mt-6 p-4 bg-white rounded-lg border border-gray-200"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h3 className="font-semibold text-gray-800 mb-2">Candidats créés :</h3>
            <div className="space-y-2">
              {candidates.map((candidate, index) => (
                <div key={index} className="flex items-center space-x-3 p-2 bg-gray-50 rounded">
                  <User className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700">
                    {candidate.firstname} {candidate.lastname} - {candidate.email}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </motion.div>

      <CreateCandidateModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        candidates={candidates}
        setCandidates={setCandidates}
      />
    </div>
  );
};

export default TestModalCandidat;
